// Version : 0.0.2
// Author : SATHISH
// LastEdit : NANDHAKUMAR
// MODFIED DATE: 5/12/2025
//Last ADD : CODE REVIEWS CHANGES DONE,CORRECTION GIVEN BY PRABA SIR
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET CHANGE MEETING DETAILS START *********************** */
export const changeMeetingListGet = (listData: any) => {
	const data = {
		GetChangeMeetingReportToken: listData,
	};
	const url = `${API_URL}postAllChangeMeeting`;
	return makeApiCall(url, data);
};
/** ***************** GET CHANGE MEETING DETAILS END *********************** */
